export default __webpack_public_path__ + "static/media/scarabknight.143c80f4.png";